import { isMobile } from '@zappar/mobile-only';
import React, { FunctionComponent, memo, useState } from 'react';
import { Jute } from '../../..';
import RectangularButton from '../Primary/RectangularButton/RectangularButton';
import QrCodePopup from './QrCodePopup/QrCodePopup';
import * as CSS from './ARRedirectButton.scss';

const ARRedirectButton: FunctionComponent = () => {
	const [showQrCode, setShowQrCode] = useState(false);

	return (
		<>
			{showQrCode && <div className={CSS.ClickHotspot} onClick={() => setShowQrCode(false)} />}
			<RectangularButton
				id="designer-embed-ar-button"
				className={CSS.BottomRight}
				onPointerDown={() => Jute.showWebembedHintGraphic(false, document)}
				onClick={() => {
					if (showQrCode) document.getElementsByTagName('body')[0].focus();
					if (isMobile()) {
						window.open(window.location.href);
						return;
					}
					setShowQrCode((prevState) => !prevState);
				}}
			>
				<span id={'designer-embed-ar-button-span'}>AR</span>
				{showQrCode && <QrCodePopup webUrl={window.location.href} />}
			</RectangularButton>
		</>
	);
};

ARRedirectButton.displayName = 'ARRedirectButton';
export default memo(ARRedirectButton);
